import ClapperBoardIcon from '@/components/Icons/ClapperBoardIcon';
import CalendarMinimalistic from '@/components/Icons/icons/CalendarMinimalistic';
import ClipboardIcon from '@/components/Icons/icons/ClipboardIcon';
import EmailIcon from '@/components/Icons/icons/CustomContracts/EmailIcon';
import Hashtag from '@/components/Icons/icons/Hashtag';
import ImageHeart from '@/components/Icons/icons/ImageHeart';
import ImpressionsIcon from '@/components/Icons/icons/ImpressionsIcon';
import InstagramMusic from '@/components/Icons/icons/InstagramMusic';
import Magnet from '@/components/Icons/icons/Magnet';
import MoneyTagIcon from '@/components/Icons/icons/MoneyTagIcon';
import CommentIcon from '@/components/Icons/icons/PlayerIcon/CommentIcon';
import HeartLikeIcon from '@/components/Icons/icons/PlayerIcon/HeartLikeIcon';
import TagAt from '@/components/Icons/icons/TagAt';


export const SOCIAL_LISTENING_FILTERS = {
  PLATFORM: 'platformType',
  CONTENT_TYPE: 'contentType',
  CAMPAIGN: 'campaign',
  LISTS: 'lists',
  LABELS: 'labels',
  SORT_BY: 'sortBy',
};

export const BRAND_MENTIONS_FILTERS = {
  CONTENT_TYPE: 'contentType',
  MENTION_TYPE: 'mentionType',
  TRACKED_SOURCE: 'trackedSource',
  DATE: 'date',
};

export const BRAND_MENTIONS_FILTER_OPTIONS = [
  { key: BRAND_MENTIONS_FILTERS.CONTENT_TYPE, label: 'Content Type', IconComponent: ClapperBoardIcon },
  { key: BRAND_MENTIONS_FILTERS.MENTION_TYPE, label: 'Mention Type', IconComponent: InstagramMusic },
  { key: BRAND_MENTIONS_FILTERS.TRACKED_SOURCE, label: 'Tracked Source', IconComponent: Magnet },
];

export const BRAND_MENTIONS_MENTION_TYPE_OPTIONS = [
  { value: 'tagged', label: 'Tagged', IconComponent: TagAt },
  { value: 'hashtag', label: 'Hashtag', IconComponent: Hashtag },
  { value: 'mentions', label: 'Mentions', IconComponent: ImageHeart },
];

export const BRAND_MENTIONS_TRACKED_SOURCE_OPTIONS = [
  { value: 'in-saral', label: 'In-SARAL' },
  { value: 'organic', label: 'Organic' },
];

export const SOCIAL_LISTENING_FILTER_OPTIONS = [
  // { key: SOCIAL_LISTENING_FILTERS.PLATFORM, label: 'Platform', IconComponent: AlbumIcon },
  { key: SOCIAL_LISTENING_FILTERS.CONTENT_TYPE, label: 'Content Type', IconComponent: ClapperBoardIcon },
  { key: SOCIAL_LISTENING_FILTERS.CAMPAIGN, label: 'Campaign', IconComponent: EmailIcon },
  { key: SOCIAL_LISTENING_FILTERS.LISTS, label: 'Lists', IconComponent: ClipboardIcon },
  { key: SOCIAL_LISTENING_FILTERS.LABELS, label: 'Labels', IconComponent: MoneyTagIcon },
];

export const SOCIAL_LISTENING_SORT_OPTIONS = [
  { key: SOCIAL_LISTENING_FILTERS.SORT_BY, label: 'Impression', value: 'impressions', IconComponent: ImpressionsIcon },
  { key: SOCIAL_LISTENING_FILTERS.SORT_BY, label: 'Comment', value: 'commentsCount', IconComponent: CommentIcon },
  { key: SOCIAL_LISTENING_FILTERS.SORT_BY, label: 'Likes', value: 'likesCount', IconComponent: HeartLikeIcon },
];

export const SOCIAL_LISTENING_SORT_LABEL_MAP = {
  impressions: 'Impressions',
  commentsCount: 'Comments',
  likesCount: 'Likes',
};

export const BRAND_MENTIONS_SORT_OPTIONS = [
  { key: SOCIAL_LISTENING_FILTERS.SORT_BY, label: 'Views', value: 'views', IconComponent: ImpressionsIcon },
  { key: SOCIAL_LISTENING_FILTERS.SORT_BY, label: 'Comments', value: 'comments', IconComponent: CommentIcon },
  { key: SOCIAL_LISTENING_FILTERS.SORT_BY, label: 'Likes', value: 'likes', IconComponent: HeartLikeIcon },
  {
    key: SOCIAL_LISTENING_FILTERS.SORT_BY,
    label: 'Date Posted',
    value: 'media_created_at',
    IconComponent: CalendarMinimalistic,
  },
];

export const BRAND_MENTIONS_SORT_LABEL_MAP = {
  views: 'Views',
  comments: 'Comments',
  likes: 'Likes',
  media_created_at: 'Date Posted',
};

export const SOCIAL_LISTEING_TABLE_HEADERS = [
  { text: 'Media' },
  { text: 'Type', align: 'center' },
  { text: 'Influencer Name' },
  { text: 'Username' },
  { text: 'Date' },
  { text: 'Impressions', align: 'right' },
  { text: 'Comments', align: 'right' },
  { text: 'Likes', align: 'right' },
  { text: 'Usage Rights', align: 'center' },
  { text: 'Labels', align: 'center' },
  { text: 'Actions', align: 'center' },
];

export const SOCIAL_LISTEING_TABLE_HEADERS_PULSE = [
  { text: 'Media' },
  { text: 'Influencer Name' },
  { text: 'Username' },
  { text: 'Date' },
  { text: 'Actions', align: 'center' },
];

export const SOCIAL_LISTENING_FEATURE_FLAG_NAME = 'social_listening';

export const DEMO_ACCOUNTS = ['646e65fd06be4bfc8326b2ec'];
export const DEMO_CAMPAIGNS = ['65d7eebb89ca0f666844630d'];